import axios from 'axios';
import api, { NEXTJS_API_URL } from './client';

export const shortlistAPI = {
  getAll: async (options = {}) => {
    try {
      // Use Next.js API for shortlists
      const params = options.params || {};
      const queryString = new URLSearchParams(params).toString();
      const url = `${NEXTJS_API_URL}/shortlists${
        queryString ? "?" + queryString : ""
      }`;

      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });

      if (response.data.status === "success") {
        return response.data;
      } else {
        return {
          status: "error",
          message: response.data.message || "Failed to load shortlists",
        };
      }
    } catch (error) {
      console.error("Error fetching shortlists:", error);
      return {
        status: "error",
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to load shortlists",
      };
    }
  },
  getById: async (id) => {
    const response = await api.get(`/shortlists/${id}`);
    return response.data;
  },
  create: async (data) => {
    try {
      const response = await axios.post(`${NEXTJS_API_URL}/shortlists`, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  update: async (id, data) => {
    const response = await api.put(`/shortlists/${id}`, data);
    return response.data;
  },
  delete: async (id) => {
    const response = await api.delete(`/shortlists/${id}`);
    return response.data;
  },
  batchAdd: async (data) => {
    const response = await api.post("/shortlists/batch", data);
    return response.data;
  },
  release: async (id) => {
    const response = await api.delete(`/shortlists/${id}/release`);
    return response.data;
  },
  getEmployerShortlists: async () => {
    const response = await api.get("/employer/shortlists");
    return response.data;
  },
};

// Application Worker API
